<template>
  <div
    class="home"
  >
    <welcome :title="title" :showBrugerInfo="false" />
    <div id="notification">
      {{ text }}
      <br/><br/>
      <button
        class="modal-default-button"
        @click="returnToHome"
      >
        Gå til forsiden
      </button>
    </div>
  </div>
</template>

<script>
import Welcome from '@/components/Home/Welcome.vue';

export default {
  name: 'home',
  components: {
    Welcome,
  },
  data: function() {
    return {
      title: process.env.VUE_APP_TITLE,
      text: this.getText(this.$route.params.id),
    };
  },
  methods: {
    getText: function(id) {
      let text = '';
      switch (id) {
        case '1': text = 'Du modtager en mail hvor du skal bekræfte dit login for at få adgang til "På Tur". Du kan lukke denne fane.'; break;
        case '2': text = 'Din konto er ikke bekræftet og du kan derfor ikke få adgang til "På tur".'; break;
        case '3': text = 'Fejl ved oprettelse af applikationsbruger.'; break;
        case '4': text = 'Fejl ved opslag af bruger.'; break;
        case '5': text = 'Du kan ikke oprettes som bruger med den angivne email.'; break;
        case '6': text = 'Du har ikke bekræftet dit login. Hvis du mistet din mail til bekræftelse, skal du kontakte support. Du kan lukke denne fane.'; break;
      }
      return text;
    },
    returnToHome() {
      switch (parseInt(this.$route.params.id)) {
        case 4:
        case 5:
        case 6:
          this.$auth.logOut();
          break;
        default:
          this.$router.push('/');
      }
    },

  },
};
</script>

<style lang="scss" scoped>
.home {
  flex: 1;
  overflow: hidden;
  position: relative;
}

#notification {
  display: flex;
  flex: 1;
  flex-direction: column;
  background-color: #ecedf4;
  min-height: 100vh;
  overflow-y: auto;
  align-items: center;
  padding-top: 100px;
  padding-left: 470px;
}

@media only screen and (max-width: $tablet-landscape-max-width),
  screen and (max-height: 800px) {
  #notification {
    padding-left: 320px;
    padding-top: 60px;
  }
}

@media only screen and (max-width: $tablet-max-width) {
  #notification {
    padding-left: 0;
    min-height: 0;
    padding-bottom: 340px;
  }
}

@media only screen and (max-width: $mobile-max-width) {
  #notification {
    padding-top: 30px;
    padding-bottom: 300px;
  }
}

</style>
